module.exports = __webpack_public_path__ + "static/img/trailer-cover.1212d3a6.webp";